<template>
  <div id="changelog">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar color="transparent" card class="mb-2">
         <v-btn color="primary" flat icon @click="$router.push('/language')">
          <v-icon>arrow_back</v-icon>
         </v-btn>
         <h4>Bản cập nhật</h4>
         <v-btn icon color="success" @click="onOpenDialogCreateUpdateChangelog(null)">
          <v-icon>add</v-icon>
         </v-btn>
        <v-spacer></v-spacer>
        <v-select
          :items="platformOptions"
          v-model="selectedPlatformOption"
          label="Platform"
          item-text="text"
          item-value="value"
          @change="onFilter"
        ></v-select>
      <v-btn
          style="color: white;"
          :color="selectedPlatformOption === 'web' ? 'teal' : 'orange'"
          @click="onFinalUpdate"
      >
      <v-icon class="mr-2">{{ selectedPlatformOption === 'web' ? 'web' : 'smartphone' }}</v-icon>
          Cập nhật ({{ selectedPlatformOption === 'web' ? 'Web' : 'Mobile' }})
      </v-btn>
      </v-toolbar>
      <v-card-text style="color: red;">Chỉ cập nhật khi nhấn nút cập nhật ở góc trên bên phải. Thêm, xoá, sửa chỉ là nháp. Phiên bản sẽ tự động sắp xếp theo ngày cập nhật.
      </v-card-text>
       <v-card style="width: 100%;">
        <v-card v-for="changelog in changelogList" :key="changelog.version">
          <div class="pl-4 pt-4">
          <i style="text-decoration: underline;">{{ changelog.version }}</i>
          </div>
          <v-card-title style="padding-top: 0;padding-bottom: 0;">
            <span class="ml-2 mr-2" style="font-size: 2rem; font-weight: bold;">{{ changelog.title }}</span>
            <span >{{ changelog.date }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="onOpenDialogCreateUpdateChangelog(changelog)" color="primary">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteOneChangelog(changelog)" color="error">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-title>

          <!-- ! Tính năng -->
          <v-card-text v-if="changelog.features && changelog.features['vi-VN'].length > 0">
            <v-chip color="orange lighten-5" text-color="orange" style="font-weight: bold;">Tính năng</v-chip>
            <div style="display: flex;">
              <ul v-if="changelog.features['vi-VN']" style="width: 50%;">
                <li v-for="feature in changelog.features['vi-VN']" :key="feature + 'vi-VN'">
                  {{ feature }}
                </li>
              </ul>
              <ul v-if="changelog.features['en-US']" style="width: 50%;">
                <li v-for="feature in changelog.features['en-US']" :key="feature + 'en-US'">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </v-card-text>

          <!-- ! Cải thiện -->
          <v-card-text v-if="changelog.improvements && changelog.improvements['vi-VN'].length > 0">
            <v-chip color="blue lighten-5" text-color="blue" style="font-weight: bold;">Cải thiện</v-chip>
            <div style="display: flex;">
              <ul v-if="changelog.improvements['vi-VN']" style="width: 50%;">
                <li v-for="improvement in changelog.improvements['vi-VN']" :key="improvement + 'vi-VN'">
                  {{ improvement }}
                </li>
              </ul>
              <ul v-if="changelog.improvements['en-US']" style="width: 50%;">
                <li v-for="improvement in changelog.improvements['en-US']" :key="improvement + 'en-US'">
                  {{ improvement }}
                </li>
              </ul>
            </div>
          </v-card-text>

          <!-- ! Sửa lỗi -->
          <v-card-text v-if="changelog.fixes && changelog.fixes['vi-VN'].length > 0">
            <v-chip color="green lighten-5" text-color="green" style="font-weight: bold;">Sửa lỗi</v-chip>
            <div style="display: flex;">
              <ul v-if="changelog.fixes['vi-VN']" style="width: 50%;">
                <li v-for="fix in changelog.fixes['vi-VN']" :key="fix + 'vi-VN'">
                  {{ fix }}
                </li>
              </ul>
              <ul v-if="changelog.fixes['en-US']" style="width: 50%;">
                <li v-for="fix in changelog.fixes['en-US']" :key="fix + 'en-US'">
                  {{ fix }}
                </li>
              </ul>
            </div>
          </v-card-text>

        </v-card>
       </v-card>
      </v-layout>
    </v-container>
    <dialog-create-update-changelog ref="dialogCreateUpdateChangelog" @add="onAddChangelog" @update="onUpdateChangelog" />
  </div>
</template>

<script>
import DialogCreateUpdateChangelog from './DialogCreateUpdateChangelog.vue';
import { mapActions } from 'vuex';

export default {
  components: { DialogCreateUpdateChangelog, },
  data () {
    return {
      platformOptions: [
        {
          text: 'Web',
          value: 'web'
        },
        {
          text: 'Mobile',
          value: 'mobile'
        }
      ],
      selectedPlatformOption: 'web',
      webChangelogs: { 'vi-VN': [], 'en-US': [] },
      mobileChangelogs: { 'vi-VN': [], 'en-US': [] },
      changelogList: [],
    };
  },
  computed: {},
  mounted () {
    this.getChangelogsData();
  },
  methods: {
    ...mapActions([
      'getLanguageByKey',
      'updateLanguage'
    ]),

    sortChangelogs () {
      this.changelogList.sort((a, b) => new Date(b.date) - new Date(a.date));
    },

    async getChangelogsData () {
      const webChangelogVi = await this.getLanguageByKey({ key: 'Changelog.List', language: 'vi-VN' }) || [];
      const webChangelogEn = await this.getLanguageByKey({ key: 'Changelog.List', language: 'en-US' }) || [];
      this.webChangelogs = this.mergeChangelogs(webChangelogVi, webChangelogEn);

      const mobileChangelogVi = await this.getLanguageByKey({ key: 'Changelog.List.Mobile', language: 'vi-VN' }) || [];
      const mobileChangelogEn = await this.getLanguageByKey({ key: 'Changelog.List.Mobile', language: 'en-US' }) || [];
      this.mobileChangelogs = this.mergeChangelogs(mobileChangelogVi, mobileChangelogEn);

      this.changelogList = this.selectedPlatformOption === 'web' ? this.webChangelogs : this.mobileChangelogs;
      this.sortChangelogs();
    },

    onFilter () {
      switch (this.selectedPlatformOption) {
        case 'web':
          this.changelogList = this.webChangelogs;
          break;
        case 'mobile':
          this.changelogList = this.mobileChangelogs;
          break;
      }
    },

    deleteOneChangelog (changelog) {
      const foundIndex = this.changelogList.indexOf(changelog);
      if (foundIndex !== -1) {
        this.changelogList.splice(foundIndex, 1);
      }
      this.sortChangelogs();
    },

    mergeChangelogs (vi, en) {
      return vi.map(vItem => {
        const eItem = en.find(e => e.version === vItem.version);

        const mergeSection = (key) => {
          if (vItem[key] || eItem[key]) {
            return {
              'vi-VN': vItem[key] || [],
              'en-US': eItem[key] || []
            };
          }
          return undefined;
        };

        const mergedItem = {
          version: vItem.version,
          title: vItem.title,
          date: vItem.date,
        };

        const sections = ['features', 'improvements', 'fixes'];
        for (const section of sections) {
          const mergedSection = mergeSection(section);
          if (mergedSection) mergedItem[section] = mergedSection;
        }

        return mergedItem;
      });
    },

    // ! Final update changelog
    convertToChangelogRequest (data) {
      const languages = ['vi-VN', 'en-US'];
      const result = {};

      languages.forEach(lang => {
        const langEntries = data.map(entry => {
          const transformedEntry = {
            version: entry.version,
            title: entry.title,
            date: entry.date
          };

          if (entry.features && entry.features[lang]) {
            transformedEntry.features = entry.features[lang];
          }
          if (entry.improvements && entry.improvements[lang]) {
            transformedEntry.improvements = entry.improvements[lang];
          }
          if (entry.fixes && entry.fixes[lang]) {
            transformedEntry.fixes = entry.fixes[lang];
          }

          return transformedEntry;
        });

        result[lang] = JSON.stringify(langEntries, null, 2);
      });

      return result;
    },

    onFinalUpdate () {
      const requestContent = this.convertToChangelogRequest(this.changelogList);
      let request = {};

      switch (this.selectedPlatformOption) {
        case 'web':
          request = {
            'Changelog.List': requestContent
          };
          break;
        case 'mobile':
          request = {
            'Changelog.List.Mobile': requestContent
          };
          break;
      }

      this.updateLanguage(request).then(() => {
        this.getChangelogsData();
        window.getApp.showMessage('Cập nhật phiên bản thành công', 'success');
      }).catch(() => {
        window.getApp.showMessage('Lỗi khi cập nhật phiên bản', 'error');
      });
    },

    // ! Add changelog
    onOpenDialogCreateUpdateChangelog (changelog) {
      this.$refs.dialogCreateUpdateChangelog.open(changelog, this.changelogList);
    },

    onAddChangelog (changelog) {
      this.changelogList.unshift(changelog);
      this.sortChangelogs();
    },

    onUpdateChangelog (changelog) {
      const index = this.changelogList.findIndex(item => item.version === changelog.version);
      if (index !== -1) {
        this.changelogList.splice(index, 1, changelog);
      }
      this.sortChangelogs();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/changelog/Changelog.vue